import { Prospector } from '@clearkit/icons';
import { CKButton } from 'clearkit';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { trackEvent } from '~/lib/tracking';
import { NewVisitorReportCrmData } from '~/pages/VisitorReport/New/types';

import { prospectorPath } from '../prospector/util';
import { ButtonContainer } from '../unified/ButtonContainer';
import { SampleModal } from './SampleModal';

const BulkSelectedCompaniesActions = ({
  // crmData,
  // crmConnected,
  selected,
  isSample,
  handleClear,
  type,
}: {
  crmData?: NewVisitorReportCrmData;
  crmConnected?: boolean;
  selected: string[];
  isSample: boolean;
  handleClear: () => void;
  type: 'visitors' | 'target_markets';
}) => {
  const [isSampleModalOpen, setIsSampleModalOpen] = useState(false);
  // For upcoming add to CRM feature:
  // const selectedForCrm = selected.filter(
  //   ({ company_domain }) =>
  //     !crmData?.[company_domain]?.inHubSpot &&
  //     !crmData?.[company_domain]?.inSalesforce,
  // );
  const length = selected.length;
  const isDisabled = length === 0;

  const handleAddProspector = () => {
    if (isSample) {
      setIsSampleModalOpen(true);
    } else {
      trackEvent(
        type === 'target_markets'
          ? 'target_markets_prospector_opened'
          : 'visitor_report_prospector_opened',
        {
          domains: selected,
          type: 'bulk',
        },
      );
    }
  };

  return (
    <ButtonContainer>
      <CKButton
        isDisabled={isDisabled}
        onClick={handleClear}
        variant="simple"
        variantColor="red"
      >
        Clear
      </CKButton>

      {/* <CKButton
          isDisabled={selectedForCrm.length === 0}
          leftIcon={<Add />}
          onClick={() => {
            if (crmConnected) {
              Modal TBD
            } else {
              history.push('/settings/configuration');
            }
          }}
          size="small"
          variant="simple"
          variantColor="blue"
        >
          Add {selectedForCrm.length} to CRM
        </CKButton> */}

      <CKButton
        as={Link}
        isDisabled={isDisabled}
        leftIcon={<Prospector />}
        onClick={handleAddProspector}
        to={
          isSample
            ? ''
            : prospectorPath({
                source: type,
                domain: selected,
              })
        }
        variant="bold"
        variantColor="blue"
      >
        Prospect companies
      </CKButton>
      <SampleModal
        isVisible={isSampleModalOpen}
        onToggle={() => setIsSampleModalOpen(!isSampleModalOpen)}
      />
    </ButtonContainer>
  );
};

export default BulkSelectedCompaniesActions;
